import React from "react"
import { NoteSections } from "./constants/Notes"
import { FileText, File } from "lucide-react"
import PropTypes from "prop-types";
import { handleErrorSentry } from "./constants/Error";

export function formatNoteName(string) {
    switch(string) {
        case("dr_manji_consult_with_eights"): {
            return "Dr. Manji - New consults 8's with dx 8's"
        }
        case ("dr_fritz_implant_consult_letter" ): {
            return "Dr. Fritz - Implant Consult Letter"
        }
        case ("dr_fritz_pathology_consult_letter" ): {
            return "Dr. Fritz - Pathology Consult Letter"
        }
        case ("dr_fritz_grafting_consult_letter" ): {
            return "Dr. Fritz - Grafting Consult Letter"
        } case ("dr_harle_complete_exam"): {
            return "Dr. Harle / Dr. Natsis - COMPLETE EXAM"
        } case ("dr_harle_restorative"): {
            return "Dr. Harle / Dr. Natsis - RESTORATIVE"
        } case ("wpd_recall_exam_dr_luong"): {
            return "WPD - Recall Exam - Dr. Luong"
        } case ("wpd_recall_exam_dr_dufresne"): {
            return "WPD - Recall Exam - Dr. Dufresne"
        } case ("wpd_np_exam_dr_luong"): {
            return "WPD - NP Exam - Dr. Luong"
        } case ("wpd_np_exam_dr_dufresne"): {
            return "WPD - NP Exam - Dr. Dufresne"
        } case ("wpd_specific_exam_dr_luong"): {
            return "WPD - Specific Exam - Dr. Luong"
        } case ("wpd_specific_exam_dr_dufresne"): {
            return "WPD - Specific Exam - Dr. Dufresne"
        } case ("wpd_scaling_visit"): {
            return "WPD - Scaling Visit"
        } case ("wpd_or_note"): {
            return "WPD - OR Note"
        } case ("love_dental_shay_template"): {
            return "Love Dental - Shay Template"
        } case ("dr_harle_emergency"): {
            return "Dr. Harle / Dr. Natsis - EMERGENCY"
        } case ("dr_harle_hygiene_recall"): {
            return "Dr. Harle / Dr. Natsis - HYGIENE RECALL"
        } case ("dr_harle_scale_appointment"): {
            return "Dr. Harle / Dr. Natsis - SCALE APPOINTMENT"
        } case ("dr_harle_extraction_treatment"): {
            return "Dr. Harle / Dr. Natsis - Extraction Treatment"
        } case ("dr_harle_ortho_appointment"): {
            return "Dr. Harle / Dr. Natsis - ORTHO APPOINTMENT"
        } case ("dr_harle_orthodontic_records"): {
            return "Dr. Harle / Dr. Natsis - ORTHODONTIC RECORDS"
        } case ("dr_harle_prosthodontic_treatment"): {
            return "Dr. Harle / Dr. Natsis - Prosthodontic Treatment"
        } case ("dr_seitz_restorative_medicine"): {
            return "Dr. Seitz - Restorative Medicine"
        }
        default: {
            return capitalizeWords(string, "_");
        }
    }
}

export function formatNoteSections(string) {
    switch(string) {
        case ("general_notes"): {
            return "General Notes / Family Medicine"
        }
        default: {
            return capitalizeWords(string, "_");
        }
    }
}


export function capitalizeWords(sentence, factor) {
    const words = sentence.split(factor);
    const capitalizedWords = words.map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });
    return capitalizedWords.join(' ');
}

export function checkExistingTitles(string) {
    const regex = /\*\*([^*]+)\*\*/g;
    return regex.test(string);
}


export function formatPhoneNumber(phoneString) {
    if (!phoneString) {
        return phoneString;
    }

    let input = phoneString.replace(/\D/g, "");
    let proper_number = "";

    if (input.length >= 10) {
        proper_number += `(${input.substring(0 , 3)})-${input.substring(3 , 6)}-${input.substring(6, 10)}`;
    } else {
        proper_number = input;
    }
    return proper_number
}

export function grabAvatar(full_name) {
    if (full_name.includes(" ")) {
        const split_name = full_name.split(" ");
        return split_name[0].substring(0, 1).toUpperCase() + split_name[1].substring(0, 1).toUpperCase();
    } else {
        return full_name.substring(0, 1).toUpperCase();
    }
}

export function createNoteText(titles, noteBodyReferences) {
    try {
        let noteText = '';
        titles.forEach((title, index) => {
            index === 0 ? noteText += `**${title}**\n` : noteText += `\n\n**${title}**\n `;
            noteText += noteBodyReferences[index]?.current?.value ?? '';
        })
        return noteText;
    } catch (error) {
        handleErrorSentry(error, "tryCatch");
    }
}

export const chooseText = (note) => {
    try {
        if (!note.user_edited_result.value || note.user_edited_result.value.length <= 0) {
            return note.generated_result.value;
        } else {
            return note.user_edited_result.value;
        }
    } catch (error) {
        handleErrorSentry(error, "tryCatch");
    }
};


export function NoteNameIcon({ note_type, size = "15px" }) {
    return NoteSections.using_note_type(note_type) === "pdf_forms" ?  <File style={{ color: `var(--${NoteSections.using_note_type(note_type)})`, width: size }} />: <FileText style={{ color: `var(--${NoteSections.using_note_type(note_type)})`, width: size }}/>
}

NoteNameIcon.propTypes = {
    note_type: PropTypes.string.isRequired,
    size: PropTypes.string,
}